import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { CustomTagDto, CustomTagReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getCustomTagOptionTitle } from "./CustomTagAutocomplete";

export interface CustomTagInlineProps extends BaseEntityInlineInheritableProps {
  entity: CustomTagDto | CustomTagReferenceDto | null | undefined;
  entityId?: string | null;
}

/** Inline brief information about the entity. */
export default function CustomTagInline({ entity, entityId, ...otherProps }: CustomTagInlineProps) {
  const request = useApiRequest(
    apiClient.customTagsApi.apiV1TagsCustomCustomTagIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      customTagId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as CustomTagDto;
  // const ref = entity as CustomTagReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={request}
      icon={<AppIcon of='customTag' inText />}
      content={<>{full && getCustomTagOptionTitle(full)} </>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Custom tag"}
    />
  );
}
